import styled from 'styled-components';

export const Content = styled.div`
  .objeto-text {
    white-space: pre-line;
  }

  .description-cell {
    width: 100%;
    max-width: 0;
    min-width: 0;

    > span {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .price-card {
    border-radius: 8px;

    .material-icons {
      font-size: 20px;
      vertical-align: text-bottom;
    }
  }

  .price-value {
    font-size: 18px;
    color: ${(props) => props.theme.$dark};
  }
`;
